module.exports = "//__CDN_HOST__/2.0.8/img/calculator-banner-2.63678157.png";